import { bool, number } from "prop-types";
import React, { memo, useMemo } from "react";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { useTranslation } from "@lib/i18n";

const TO = ["to-60%", "to-70%", "to-80%", "to-90%", "to-100%"];

const ServiceTile = ({ duration, isOffset = false, small = false }) => {
  const { t } = useTranslation();

  const title = useMemo(
    () => `MY AMI CARE ${duration} ${t(duration === 1 ? "year" : "years")}`,
    [duration]
  );

  return (
    <div
      className={`size-full relative bg-primaryBlue bg-gradient-to-br from-primaryOrange ${
        TO[duration - 1]
      } select-none`}
    >
      {duration && (
        <span className="font-semibold normal-case block relative top-0.5 left-1 text-left leading-1 text-white">
          <var
            className={`not-italic ${small ? "text-xl" : "text-[2.7rem]/1"}`}
          >
            {duration}
          </var>
          <span className="text-lg ml-2">
            {t(duration === 1 ? "year" : "years")}
          </span>
        </span>
      )}
      <img
        alt={title}
        className={`pointer-events-none absolute bottom-1 ${
          small ? "size-12" : "size-16"
        } ${isOffset ? "left-1" : "right-1"}`}
        src={getStaticAssetURL("/images/gallery/service/andy_care.svg")}
      />
    </div>
  );
};

ServiceTile.propTypes = {
  duration: number,
  isOffset: bool,
  small: bool,
};

export default memo(ServiceTile);
